import useSWR from 'swr';
import { API_FETCH_ENTITY_CUSTOMISATIONS } from '../api/configurationScreenServices';

const fetcher = async () => {
  const res = await API_FETCH_ENTITY_CUSTOMISATIONS();
  if (res?.status !== 200) throw new Error('entity customisations fetch failed');
  return res.data;
};

const entityCustomisationsKey = 'entityCustomisations';

/**
 * Fetches entity customisations (e.g., SingularName for white-labeling).
 * Data is cached and never refetched until page refresh.
 * Not fetched on mount - only when hook is first called.
 */
export function useEntityCustomisations() {
  return useSWR(entityCustomisationsKey, fetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false
  });
}
